














































































import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import TreeItem from '@/components/TreeItem.vue';
import {STreeData} from '@/components/dto/STreeData';
import {STreeItem, STreeItemImpl} from "@/components/dto/STreeItem";
import {ObjUtils} from "@/components/utils/ObjUtils";
import {v4 as uuid_v4} from "uuid";
import {SPropTypeEnum} from "@/components/dto/SPropTypeEnum";
import {RTreeServices, RTreeServicesImpl} from "@/services/RTreeServices";

@Component({
        components: {TreeItem}
    })
    export default class Tree extends Vue {
        @Prop() treeData!: STreeData;
        @Prop() inputPlainText!: boolean;
        @Prop({default: false}) readonly!: boolean;
        @Prop() insertCode!: number;
        private editItemData: STreeItem = STreeItemImpl.empty();
        private openModal: boolean = false;
        private tmpItemData: STreeItem = STreeItemImpl.empty();
        private copyItemData: STreeItem = STreeItemImpl.empty();
        private copyPaste: boolean = false;
        private SSTRING:SPropTypeEnum = SPropTypeEnum.SSTRING;
        private SNUMBER:SPropTypeEnum = SPropTypeEnum.SNUMBER;
        private SBOOLEAN:SPropTypeEnum = SPropTypeEnum.SBOOLEAN;
        private copyPasteItemsName: Array<string> = [];
        private showOutpuType: boolean = false;
        private isAllOpened: boolean = false;
        private isGenerateAllItems:boolean = false;
        private treeService: RTreeServices = new RTreeServicesImpl();

        created(){
          if(this.treeData.treeItems.length >0){
            this.treeData.treeItems[this.treeData.treeItems.length -1].isLastItem = true;
            this.treeData.treeItems[this.treeData.treeItems.length -1].isLastEditItem = true;
          }
        }

        get rootDataTypeArray(){
          return this.treeData.type === SPropTypeEnum.SARRAY;
        }

        get optionsPropType(){
          return [{value: '', text: this.$i18n.t('FormatterMessages.editItem.selectOptions')},
                  {value: SPropTypeEnum.SOBJECT, text: 'object'},
                  {value: SPropTypeEnum.SARRAY, text: 'array'},
                  {value: SPropTypeEnum.SSTRING, text: 'string'},
                  {value: SPropTypeEnum.SNUMBER, text: 'number'},
                  {value: SPropTypeEnum.SBOOLEAN, text: 'boolean'},
                  {value: SPropTypeEnum.SNULL, text: 'null'}
          ]
        }
        get optionsPropOutputType(){
          let options: Array<{}> = [];
          options.push({value: '', text: this.$i18n.t('FormatterMessages.editItem.selectOptions')});
          if(this.editItemData.propType === SPropTypeEnum.SOBJECT){
            options.push({value: SPropTypeEnum.SOBJECT, text: 'object'});
            options.push({value: SPropTypeEnum.SSTRING, text: 'string'});
          }else if(this.editItemData.propType === SPropTypeEnum.SARRAY){
            options.push({value: SPropTypeEnum.SARRAY, text: 'array'});
            options.push({value: SPropTypeEnum.SSTRING, text: 'string'});
          }
          return options;
        }

        isLastGenerated(){
          this.treeService.setLastGeneratedAllItems(this.treeData.treeItems, true);
        }

        @Watch('insertCode')
        watchInsertCode(newValue: number, oldValue: number){
          if(newValue !== oldValue){
            this.isAllOpened = false;
            this.isGenerateAllItems = false;
          }
        }

        @Watch('editItemData.propType')
        watchPropType(newValue: SPropTypeEnum, oldValue: SPropTypeEnum){
          if(this.optionsPropOutputType.length > 1){
            this.showOutpuType = true;
          }else {
            this.showOutpuType = false;
          }
          if(newValue === SPropTypeEnum.SNULL){
            this.editItemData.propValue = SPropTypeEnum.SNULL;
          }
          if(newValue === SPropTypeEnum.SBOOLEAN && newValue !== oldValue){
            this.editItemData.propValue = false;
          }
        }

        openAllChildren(){
          this.isAllOpened = !this.isAllOpened;
          this.treeService.updateAllChildrenOpened(this.isAllOpened, this.treeData.treeItems);
        }

        openChildren(data: {item: STreeItem, isOpen: boolean}){
          data.item.isOpen = true;
          this.treeService.updateAllChildrenOpened(data.isOpen, data.item.propChildren);
        }

        selectAllItem(){
          this.isGenerateAllItems = !this.isGenerateAllItems;
        }

        editItem(item: STreeItem){
          this.editItemData = ObjUtils.assign(item, STreeItemImpl.empty());
          this.tmpItemData = item;
          this.openModal = true;
        }

        saveEditItem(){
          if(this.editItemData.propType === SPropTypeEnum.SOBJECT && this.editItemData.propOutputType === SPropTypeEnum.SOBJECT){
            this.editItemData.startTag = "{";
            this.editItemData.endTag = "}";
            this.editItemData.propValue = '';
          }else if(this.editItemData.propType === SPropTypeEnum.SARRAY){
            this.editItemData.startTag = "[";
            this.editItemData.endTag = "]";
            this.editItemData.propValue = '';
          }else{
            this.editItemData.startTag = "";
            this.editItemData.endTag = "";
          }
          ObjUtils.assign(this.editItemData, this.tmpItemData);
          this.openModal = false;
        }

        copyItem(data: STreeItem){
          this.copyPaste = true;
          this.copyItemData = data;
          this.toggleCopyPaste(this.copyPaste, this.treeData.treeItems);

        }

        pasteItem(data: STreeItem){
         this.pushCopyItem(data, this.treeData.treeItems);
        }

        pasteRootItem(){

          let copyCounter: number = this.treeData.treeItems.reduce((prev: number, next) => prev > next.copyCounter ? prev : next.copyCounter, 0);
          this.treeData.treeItems.push(this.createPasteItem(copyCounter + 1));
        }

        toggleCopyPaste(toggle: boolean, item: STreeItem[]){
          item.map(i => {
            i.toggleCopyPaste = toggle;
            this.toggleCopyPaste(toggle, i.propChildren);
          })
        }

        pushCopyItem(findItem: STreeItem, item: STreeItem[]){
          item.map(i => {
            if(i.itemId === findItem.itemId){
              let copyCounter: number = i.propChildren.reduce((prev: number, next) => prev > next.copyCounter ? prev : next.copyCounter, 0);
              i.propChildren.push(this.createPasteItem(copyCounter + 1));
            }else {
              this.pushCopyItem(findItem, i.propChildren);
            }
          });
        }

        createPasteItem(copyCounter: number): STreeItem{
          let pasteItem = ObjUtils.deepCopy(this.copyItemData);
          pasteItem.copyCounter = copyCounter;
          pasteItem.propName = `${pasteItem.propName}NEW-${pasteItem.copyCounter}`;
          if(this.copyPasteItemsName.find(item => item === pasteItem.propName)){
            this.copyPasteItemsName.push(pasteItem.propName);
          }
          pasteItem.itemId = uuid_v4();
          this.treeService.refreshUUIDAllChildren(pasteItem.propChildren);
          return pasteItem;
        }

        addRootItem(){
          this.copyItemData = STreeItemImpl.empty();
          let copyCounter: number = this.treeData.treeItems.reduce((prev: number, next) => prev > next.copyCounter ? prev : next.copyCounter, 0);
          this.treeData.treeItems.push(this.createPasteItem(copyCounter + 1));
        }

        addItem(item: STreeItem){
          let callRefreshRoot: boolean = false;
          if(this.treeData.treeItems.find(item => item.itemId === item.itemId)){
            callRefreshRoot = true;
          }
          item.itemId = uuid_v4();
          let newChild:STreeItem = STreeItemImpl.empty();
          let copyCounter: number = item.propChildren.reduce((prev: number, next) => prev > next.copyCounter ? prev : next.copyCounter, 0);
          newChild.copyCounter = copyCounter + 1;
          newChild.propName = `${newChild.propName}NEW-${newChild.copyCounter}`;
          item.propChildren.push(newChild);
          if(callRefreshRoot){
            this.emitRefreshRoot();
          }
        }

        @Emit('refresh-root')
        emitRefreshRoot(){
          return;
        }

        removeItem(item:STreeItem){
          const removeItem = this.treeService.findRemoveItem(this.treeData.treeItems, item.itemId);
          this.treeData.treeItems = removeItem;
        }
    }
